  const BUSCANDO = (state, payload) => {
    state.buscando = payload
  }
  
  // const INSERIR_LISTA_USUARIOS = (state, payload) => {
  //   state.items = payload
  // }
  
  // const INSERIR_USUARIO = (state,  payload) => {
  //   state.items.push(payload)
  // }
  
  // const INSERIR_USUARIO_SELECIONADO = (state,  payload) => {
  //   state.selecionado = payload
  // }
  
  // const ATUALIZAR_USUARIO = (state, payload) => {
  //   state.items = state.items.map(usuario => {
  //     if(usuario.id === payload.id) {
  //       return payload;
  //     }
  //     return usuario
  //   })
  // }
  
  // const DELETAR_USUARIO = (state, payload) => {
  //   state.items = state.items.filter(usuario => usuario.id !== payload.id)
  // }

  const INSERIR_LISTA_MENUS = (state, payload) => {
    state.menus = payload
  }
  
  const INSERIR_PERFIL_SELECIONADO = (state, payload) => {
    state.perfil = payload
  }

  const LISTA_MENUS_X_PERFIS = (state, payload) => {
    state.menusPorPerfis = payload
  }

  export {
    BUSCANDO,
    // INSERIR_LISTA_USUARIOS,
    // INSERIR_USUARIO,
    // INSERIR_USUARIO_SELECIONADO,
    INSERIR_PERFIL_SELECIONADO,
    // ATUALIZAR_USUARIO,
    // DELETAR_USUARIO,
    INSERIR_LISTA_MENUS,
    LISTA_MENUS_X_PERFIS
  }